<template>
  <div
    :class="{
      excluded: hoverCand == candidate.email,
    }"
  >
    <div
      class="kanban-main-cards d-flex"
      :style="!tagFiltered && 'border-radius: 8px !important'"
    >
      <div class="w-15 position-relative">
        <div
          class="mr-2 position-relative"
          :class="
            candidate.customFields &&
            candidate.customFields.imageMedia &&
            candidate.customFields.imageMedia != null
              ? 'common-sm-profile-transparet-icon'
              : 'common-sm-profile-icon'
          "
        >
          <b-avatar
            v-if="
              candidate.customFields &&
              candidate.customFields.imageMedia &&
              candidate.customFields.imageMedia != null
            "
            :src="candidate.customFields.imageMedia"
          ></b-avatar>
          <b-avatar v-else :text="candidate.name[0].toUpperCase()"></b-avatar>
        </div>
      </div>
      <div class="w-85">
        <div class="d-flex">
          <div class="w-75 text-truncate kanban-maincards-mainhead">
            {{ candidate.name }}
          </div>
          <div
            class="
              w-25
              d-flex
              align-items-center
              position-relative
              justify-content-end
            "
          >
            <img
              v-if="
                selectedCandidate.candidateID == candidate.candidateID &&
                viewCandidateModal
              "
              src="../../assets/img/newcreatejob/hideicon.svg"
              alt=""
              class="pointer"
            />
            <img
              v-else
              :class="isSchedule && 'disabled-kanban-img'"
              @click="!isSchedule && $emit('view-preview')"
              src="../../assets/img/newkanban/view.svg"
              alt=""
              class="pointer"
            />
            <img
              v-if="
                Object.keys(candidate).includes('resume') && !candidate.resume
              "
              @click.stop="
                isSchedule || jobOnHold
                  ? ''
                  : selectedID != candidate.email
                  ? selectCand()
                  : closeCand()
              "
              :class="(isSchedule || jobOnHold) && 'disabled-kanban-img'"
              class="ml-2 kanban-image-hover pointer"
              src="../../assets/img/newkanban/more.svg"
              alt=""
            />
            <div
              :ref="'closecard' + candidate.email"
              class="kanban-more-option-card"
              v-if="selectedID == candidate.email"
            >
              <div
                @click="closeCand(), $emit('upload-resume')"
                class="kanban-more-option-card-input"
              >
                <img
                  src="../../assets/new-icons/attachment-icon.svg"
                  class="mr-1"
                  alt=""
                />
                Upload Resume
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <img src="../../assets/img/newkanban/mail.svg" alt="" />
          <span class="w-70 text-truncate kanban-maincards-mailncall ml-1">
            {{ candidate.email }}
          </span>
        </div>
        <div class="mt-1 w-100">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="kanban-maincards-mailncall">
              <img src="../../assets/img/newkanban/phone.svg" alt="" />
              {{ candidate.phoneNumber }}
            </div>
            <div
              class="kanban-maincards-nottriggered"
              :style="
                candidate.status == '4' || candidate.status == '1'
                  ? 'color :#038E00;'
                  : 'color: #eb0002'
              "
            >
              {{ candidate.resumeRating ? candidate.resumeRating : 0 }}% Match
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      ref="container"
      v-if="
        tagFiltered &&
        candidate.customFields.notesTags &&
        candidate.customFields.notesTags.length != 0
      "
      class="kanbancard-tags-container d-flex align-items-center gap-10"
    >
      <div
        v-for="(tag, index) in visibleTags"
        :key="index"
        class="kanbancards-skilltags fs-12 fw-400 font-lato color-mainblue"
        :style="
          visibleTags.length == 1 &&
          (remainingCount > 1 ||
            (remainingCount === 1 && visibleTags.length > 0)) &&
          'max-width: 195px !important;'
        "
        :class="visibleTags.length == 1 && 'kanban-tag-truncate'"
      >
        #{{ tag }}
      </div>

      <div
        :ref="'showmoreskills' + candidate.candidateID"
        v-if="
          remainingCount > 1 || (remainingCount === 1 && visibleTags.length > 0)
        "
        :id="'showmoreskills' + candidate.candidateID"
        class="
          kanbancards-skilltags
          fs-12
          fw-400
          font-lato
          color-mainblue
          pointer
        "
      >
        +{{ remainingCount }} more
      </div>
      <b-tooltip
        @shown="onTooltipShown"
        ref="tooltip"
        :target="'showmoreskills' + candidate.candidateID"
        triggers="click"
        placement="bottom"
        @hidden="$emit('show-blur', false)"
        :id="'tooltip' + candidate.candidateID"
        :custom-class="'kanban-skill-tooltip'"
      >
        <template
          v-if="candidate.notes && Object.keys(candidate.notes).length != 0"
        >
          <div class="fs-12 fw-600 font-mont color-e0e0e0">
            {{ candidate.notes.noteCreatedBy }}
            <span class="color-abb1b9 fs-11 fw-500 font-lato font-italic">
              ({{ candidate.notes.createdAt }})
            </span>
          </div>
          <div class="font-mont fw-500 fs-12 color-white mt-1">
            {{ candidate.notes.note }}
          </div>
        </template>

        <div
          ref="tooltipTags"
          class="mt-2 d-flex align-items-center gap-10 flex-wrap"
        >
          <div
            v-for="(tag, index) in visibleSubTags"
            :key="index"
            class="kanbancards-skilltags fs-12 fw-400 font-lato color-mainblue"
          >
            #{{ tag }}
          </div>
          <div
            @click="$emit('view-candidate', 'show-note')"
            v-if="count > 0"
            class="
              kanbancards-skilltags
              fs-12
              fw-400
              font-lato
              color-mainblue
              pointer
            "
          >
            +{{ count }} more
          </div>
        </div>
      </b-tooltip>
    </div>
  </div>
</template>
<script>
import { calculateVisibleSubTags, calculateVisibleTags } from "./kanbanHelpers";
export default {
  name: "applied",
  data() {
    return {
      visibleTags: [],
      remainingCount: 0,
      visibleSubTags: [],
      count: 0,
    };
  },
  props: {
    particularJob: Object,
    candidate: Object,
    selectedID: String,
    process: Object,
    isSchedule: Boolean,
    jobOnHold: Boolean,
    selectedCandidate: Object,
    viewCandidateModal: Boolean,
    tagFiltered: Boolean,
    hoverCand: String,
  },
  mounted() {
    document.addEventListener("click", this.closeOnOutside);
    if (
      this.candidate.customFields.notesTags &&
      this.candidate.customFields.notesTags.length != 0
    ) {
      this.calculateVisibleTags();
      this.calculateVisibleSubTags(this.candidate.customFields.notesTags);
      window.addEventListener("resize", this.calculateVisibleTags);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOnOutside);
    if (
      this.candidate.customFields.notesTags &&
      this.candidate.customFields.notesTags.length != 0
    ) {
      window.removeEventListener("resize", this.calculateVisibleTags);
    }
  },
  methods: {
    selectCand() {
      if (this.hoverCand == this.candidate.email) this.removeTooltip();
      this.$emit("select-cand", this.candidate.email);
    },
    closeCand() {
      this.$emit("select-cand", "");
    },
    onTooltipShown() {
      this.$emit("show-blur", true);
    },
    calculateVisibleTags() {
      calculateVisibleTags(this);
    },
    calculateVisibleSubTags(tags) {
      calculateVisibleSubTags(tags, this);
    },
  },
  closeOnOutside(event) {
    let id = "closecard" + this.candidate.email;
    if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
      this.$emit("select-cand", "");
      // Close the dropdown
    }
    const triggerRef =
      this.$refs["showmoreskills" + this.candidate.candidateID];
    if (triggerRef && !triggerRef.contains(event.target)) {
      this.$emit("show-blur", false);
      this.$refs.tooltip.$emit("close");
    }
  },
};
</script>
<style scoped></style>
